import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgDatepickerModule } from 'ng2-datepicker';
import { NgxDateRangePickerModule } from 'ngx-daterangepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  GenericModule,
  AccountModule,
  constants,
  EnvironmentModel,
  // LandingPage,
  StorageKeysModel, JwtHttpInterceptor, AppInsightsService, LandingPage, ProfileService, AuthService
} from 'common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { environmentFactory } from '../environment';
//import { DefaultLandingPage } from './default-landing-page';
import { InteractionModule } from './interaction/interaction.module';
import { storageKeys } from './constants';
import {AppConfig} from "@app-so/app.config";
import {initializeKeycloak} from '@app-so/init/keycloak-init.factory';
import {KeycloakAngularModule, KeycloakService} from "keycloak-angular";
import {DefaultLandingPage} from "@app-so/default-landing-page";
import {StorageService} from "@generic/services/storage.service";
import {UrlService} from '@app-so/participants/services/urlService';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

export function initializeApp(appConfig: AppConfig):EnvironmentModel {
  appConfig.load();
  return AppConfig.settings;
}
export function jwtOptionsFactory(environment: EnvironmentModel) {
  return {
    tokenGetter: () => {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + storageKeys.auth + '=');
      return parts
        .pop()
        .split(';')
        .shift();
    },
    whitelistedDomains: ['localhost:5000', environment.apiDomain]
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    NgxDateRangePickerModule,
    NgDatepickerModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    AccountModule,
    InteractionModule,
    GenericModule.forRoot(),
    HttpClientModule,
    KeycloakAngularModule,
    FormsModule,
    FormlyModule.forRoot(),
    BrowserAnimationsModule,
    NgbModule,
    // tslint:disable-next-line:max-line-length
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [EnvironmentModel]
      }
    })
  ],
  providers: [
    AppConfig,
    UrlService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtHttpInterceptor,
      multi: true
    },
    AppConfig,
    {
      provide: EnvironmentModel,
      useFactory: initializeApp,
      deps: [AppConfig],
      //multi: true
    },
    { provide: LandingPage, useClass: DefaultLandingPage },
    { provide: StorageKeysModel, useValue: storageKeys },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfig) => () => config.load(),
      deps: [AppConfig],
      multi: true
    },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      useValue: storageKeys,
      deps: [KeycloakService,AppConfig,ProfileService,StorageService],
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
